module.exports = __webpack_public_path__ + "img/01-T.a43c4c8f.png";